module.exports = __webpack_public_path__ + "img/showcase-stats-en-ca.e6ad2fe9.jpg";